import { StyleSheet } from 'react-native';
import { BLUE_GREY_200, BLUE_GREY_300, LILAC_400, LILAC_700, tokens } from '@airtel/air-design-system';
export var getComparePlanCardStyles = props => {
  var isTableView = props.isTableView,
    isFirstVerticalItem = props.isFirstVerticalItem,
    isLastVerticalItem = props.isLastVerticalItem,
    isLastHorizontalItem = props.isLastHorizontalItem,
    index = props.index,
    theme = props.theme;
  var _tokens$spacing = tokens.spacing,
    SPACING_0 = _tokens$spacing.SPACING_0,
    SPACING_1 = _tokens$spacing.SPACING_1,
    SPACING_4 = _tokens$spacing.SPACING_4,
    SPACING_8 = _tokens$spacing.SPACING_8,
    SPACING_12 = _tokens$spacing.SPACING_12,
    SPACING_16 = _tokens$spacing.SPACING_16;
  return StyleSheet.create({
    planDetailsCard: Object.assign({
      borderWidth: 0,
      borderBottomLeftRadius: SPACING_4,
      borderBottomRightRadius: SPACING_0,
      paddingHorizontal: SPACING_4,
      paddingVertical: SPACING_0
    }, isTableView && {
      paddingHorizontal: SPACING_4,
      paddingVertical: SPACING_0,
      borderWidth: SPACING_0,
      backgroundColor: LILAC_400
    }),
    planDetailsStyle: Object.assign({
      marginBottom: SPACING_12
    }, isTableView && {
      marginBottom: SPACING_0,
      paddingHorizontal: SPACING_8,
      borderBottomWidth: SPACING_1,
      borderBottomColor: theme == 'white' ? BLUE_GREY_200 : LILAC_700,
      backgroundColor: theme == 'white' ? BLUE_GREY_200 : LILAC_400
    }),
    planCardBottomCta: Object.assign({}, isTableView && {
      paddingBottom: SPACING_16
    }),
    planDetailsContainer: Object.assign({
      marginTop: SPACING_12
    }, isTableView && Object.assign(Object.assign(Object.assign(Object.assign({
      borderTopLeftRadius: isFirstVerticalItem && index == 0 ? SPACING_16 : SPACING_0,
      borderTopRightRadius: isFirstVerticalItem && isLastHorizontalItem ? SPACING_16 : SPACING_0,
      borderBottomLeftRadius: isLastVerticalItem && index == 0 ? SPACING_16 : SPACING_0,
      borderBottomRightRadius: isLastVerticalItem && isLastHorizontalItem ? SPACING_16 : SPACING_0,
      backgroundColor: theme == 'white' ? BLUE_GREY_200 : LILAC_400,
      borderColor: theme == 'white' ? BLUE_GREY_300 : LILAC_700,
      borderLeftWidth: 0.5,
      borderRightWidth: 0.5
    }, isFirstVerticalItem && {
      paddingTop: SPACING_16
    }), !isFirstVerticalItem && {
      marginTop: SPACING_0
    }), isLastHorizontalItem && {
      borderRightWidth: 1
    }), index == 0 && {
      borderLeftWidth: 1
    })),
    comparePlanCardWrapper: {
      display: 'flex',
      flex: 1
    },
    dropdown: Object.assign({}, isTableView && {
      marginHorizontal: SPACING_4
    })
  });
};